import { Link } from 'gatsby'
import React from 'react'

import heroImage from '../images/gain-hero.jpg'

function Hero() {
	return (
		<section className='hero' style={{ backgroundImage: `url(${heroImage})` }}>
			<div className='hero__content'>
				<div className='hero__text'>
					<h2 data-aos='fade-right'>
						<span>Ponemos en valor</span> <span>tus inversiones</span>
					</h2>
					<p className='lead' data-aos='fade-right' data-aos-delay='500'>
						GAIN mejora, facilita, asesora y ordena para lograr que tus inversiones sean más
						rentables
					</p>
					<a href='/#contacto' className='cta' data-aos='fade-up'>
						<span>Consultanos</span>
					</a>
				</div>
			</div>

			<Link to='/#quienes-somos' className='scroll'>
				<span className='read-only'>Scroll</span>
				<span className='arrow-scroll'></span>
			</Link>
		</section>
	)
}

export default Hero
